import { ServerApi } from "../widgets/serverApi/serverApi.js";

let fdServerApi = document.getElementById('fdServerApi');
let opts = {};
let fdServerApiWidget = new ServerApi(fdServerApi, opts);